/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogRouteConfig, TextMessageDialogBaseComponent } from '@gh/core-ui';

@Component({
  selector: 'gh-text-message-dialog',
  template: require('./text-message-dialog.component.html'),
  styles: [require('./text-message-dialog.component.scss')],
})
export class TextMessageDialogComponent<A> extends TextMessageDialogBaseComponent<A> {
  constructor(dialogRef: MatDialogRef<any>) {
    super(dialogRef);
  }
}

export const textMessageDialogRoute: DialogRouteConfig<TextMessageDialogComponent<any>> = {
  component: TextMessageDialogComponent,
  config: { minWidth: '300px', minHeight: '200px' },
};
